export const taskType = {
	'ITEMLIST': { id: 0, type: 'ItemList' }
};

export const subTaskType = {
	'PRACTICE': { id: 1, type: 'practice' },
	'TASKS': { id: 1, type: 'tasks' },
};

export const taskSegment = {
	'INSTRUCTION': 'Instruction',
	'PRACTICE': 'Practice',
	'PRACTICECOMPLETE': 'PracticeComplete',
	'TASK': 'Task',
	'TASKCOMPLETE': 'TaskComplete'
};

export const terminationType = {
	'TIMEDOUT': 'Timed out'
};

export const gridTemplates = {
	'2x3Verbal': {
		testSize: null,
		respSize: { width: 270, height: 178 }
	},
	'Equations': {
		testSize: { width: 909, height: 236 },
		respSize: { width: 102, height: 102 }
	},
	'Matrices': {
		testSize: { width: 585, height: 300 },
		respSize: { width: 102, height: 73 }
	},
	'Numberline': {
		testSize: { width: 606, height: 102 },
		respSize: { width: 102, height: 102 }
	},
	'Thinking': {
		testSize: { width: 585, height: 300 },
		respSize: { width: 102, height: 102 }
	},
	'2x2': {
		testSize: { width: 148, height: 148 },
		respSize: { width: 61, height: 61 }
	},
	'2x2LargeFolding': {
		testSize: { width: 229, height: 288 },
		testOffset: { right: 41 },
		respSize: { width: 61, height: 61 }
	},
	'2x2SmallFolding': {
		testSize: { width: 225, height: 249 },
		testOffset: { top: 8, right: 52 },
		respSize: { width: 61, height: 61 },
	},
	'2x3': {
		testSize: { width: 234, height: 148 },
		respSize: { width: 61, height: 61 }
	},
	'2x3LargeFolding': {
		testSize: { width: 327, height: 230 },
		testOffset: { top: 9, right: 42 },
		respSize: { width: 61, height: 61 }
	},
	'2x3SmallFolding': {
		testSize: { width: 290, height: 200 },
		testOffset: { top: 52, right: 56 },
		respSize: { width: 61, height: 61 }
	},
	'3x2': {
		testSize: { width: 148, height: 234 },
		respSize: { width: 61, height: 61 }
	},
	'3x2Folding': {
		testSize: { width: 222, height: 356 },
		testOffset: { top: 9, right: 49 },
		respSize: { width: 61, height: 61 }
	},
	'3x3': {
		testSize: { width: 234, height: 234 },
		respSize: { width: 61, height: 61 }
	},
	'3x3Folding': {
		testSize: { width: 331, height: 352 },
		testOffset: { right: 46 },
		respSize: { width: 61, height: 61 }
	},
	'Box': {
		testSize: { width: 247, height: 183 },
		respSize: { width: 90, height: 58 }
	}
};

export const getTestByVersion = versionId => {
	const tests = {
		Verbal: [7, 8, 9],
		NonVerbal: [10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25],
		Quant: [26, 27, 28, 29, 30, 31, 32]
	};

	return Object.keys(tests).find(test => tests[test].includes(versionId));
};

export const getTestTimeLimit = grade => {
	const g = grade.toString();

	if (['PreK', 'K', '1', '2'].includes(g)) {
		return 30;
	} else if (['3', '4', '5', '6', '7', '8', '9', '10', '11', '12'].includes(g)) {
		return 35;
	} else {
		return 40;
	}
};

export const getInstructions = (grade, versionId) => {
	const test = getTestByVersion(versionId);
	const PreK = ['PreK', 'K'];
	const BD = ['1', '2', '3', '4'];
	const EG = ['5', '6', '7', '8', '9', '10', '11', '12'];
	const g = grade.toString();

	switch (test) {
		case 'Verbal':
			return 'verbalInstructions';

		case 'NonVerbal':
			if (PreK.includes(g)) {
				return 'nonVerbalInstructionsPreK';
			} else if (BD.includes(g)) {
				return 'nonVerbalInstructionsBD';
			} else if (EG.includes(g)) {
				return 'nonVerbalInstructionsEG';
			} else {
				return null;
			}

		case 'Quant':
			if (PreK.concat(BD).includes(g)) {
				return 'quantInstructionsBD';
			} else if (EG.includes(g)) {
				return 'quantInstructionsEG';
			} else {
				return null;
			}

		default:
			return null;
	}
};

export const getTasks = (tasks, type, subType) => {
	if (tasks) {
		const taskType = Object.values(tasks).find(task => task.id === type.id);

		if (taskType) {
			return taskType[subType.type];
		}
	}
};